import React, { Component } from 'react'
import { Button, Card, DatePicker, Input, Modal, Select, Tooltip } from 'antd'
import moment from 'moment'
import { TableComp } from 'sz-react-utils'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import Request from '../../request'

const { Option } = Select
const { Search } = Input
const { RangePicker } = DatePicker

const CATEGORY_LABELS = {
  production_order: 'Production Order',
  manufacturing_order: 'Production Order',
  inward: 'Inward',
  outward: 'Outward',
}

const SUBCATEGORY_LABELS = {
  general: 'General',
  production_as_on: 'Production As On',
  completion: 'Completion',
  consumable: 'Consumable',
  manufacturing_order_outward: 'Manufacturing Order',
  dispatch_order: 'Dispatch Order',
  repair_order: 'Repair Order',
  outward_for_guard: 'Outward For Guard',
  box_picture: 'Box Picture',
  material: 'Material',
  counting_slip: 'Counting Slip',
}

const MEDIA_LABELS = {
  photo: 'Photo',
  video: 'Video',
}

const resolveMediaType = (record) => {
  if (record.mediaType) {
    return record.mediaType
  }
  return record.mimeType && record.mimeType.indexOf('video/') === 0 ? 'video' : 'photo'
}

const formatIst = (value) => {
  return value
    ? moment(value)
        .utcOffset(330)
        .format('DD MMM YYYY, hh:mm:ss A [IST]')
    : ''
}

class Photos extends Component {
  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.state = {
      count: 0,
      currentPage: 1,
      users: [],
      category: undefined,
      subcategory: undefined,
      mediaType: undefined,
      orderId: undefined,
      uploaderMobile: undefined,
      capturedRange: undefined,
      previewUrl: undefined,
      previewMediaType: undefined,
    }
  }

  componentDidMount() {
    Request.loadUser({ results: 10000000000000 }).then(({ data }) => {
      this.setState({ users: data || [] })
    })
  }

  apiRequest = async (params) => {
    if (params.page) {
      this.setState({ currentPage: params.page })
    }
    if (!params.sortField) {
      params.sortField = 'capturedAt'
      params.sortOrder = 'descend'
    }

    const {
      category,
      mediaType,
      orderId,
      subcategory,
      uploaderMobile,
      capturedRange,
    } = this.state
    if (category) {
      params.category = category
    }
    if (subcategory) {
      params.subcategory = subcategory
    }
    if (mediaType) {
      params.mediaType = mediaType
    }
    if (orderId) {
      params.orderId = orderId
    }
    if (uploaderMobile) {
      params.uploaderMobile = uploaderMobile
    }
    if (capturedRange && capturedRange.length === 2) {
      params.capturedAt = {
        $gte: capturedRange[0].startOf('day').toISOString(),
        $lte: capturedRange[1].endOf('day').toISOString(),
      }
    }

    const data = await Request.getAllPhotos(params)
    this.setState({ count: data.total || 0 })
    return data
  }

  reload = (updates) => {
    this.setState(updates, () => {
      this.table.current.reload()
    })
  }

  render() {
    const { count, currentPage, users, previewUrl, previewMediaType } = this.state
    const columns = [
      {
        title: 'S.No',
        dataIndex: 'sno',
        key: 'sno',
        width: 60,
        render: (value, item, index) => (currentPage - 1) * 10 + index + 1,
      },
      {
        title: 'Media',
        dataIndex: 'imageUrl',
        key: 'imageUrl',
        width: 130,
        render: (url, record) => {
          const mediaType = resolveMediaType(record)
          if (mediaType === 'video') {
            return (
              <video
                muted
                playsInline
                preload="metadata"
                src={url}
                style={{ cursor: 'pointer', height: 78, objectFit: 'cover', width: 100 }}
                onClick={() => this.setState({ previewUrl: url, previewMediaType: mediaType })}
              />
            )
          }
          return (
            <img
              alt="Uploaded capture"
              src={url}
              style={{ cursor: 'pointer', height: 78, objectFit: 'cover', width: 100 }}
              onClick={() => this.setState({ previewUrl: url, previewMediaType: mediaType })}
            />
          )
        },
      },
      {
        title: 'Type',
        key: 'mediaType',
        width: 90,
        render: (value, record) => MEDIA_LABELS[resolveMediaType(record)] || 'Photo',
      },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        render: (value) => CATEGORY_LABELS[value] || value,
      },
      {
        title: 'Subcategory',
        dataIndex: 'subcategory',
        key: 'subcategory',
        render: (value) => SUBCATEGORY_LABELS[value || 'general'] || value,
      },
      {
        title: 'Order ID',
        dataIndex: 'orderId',
        key: 'orderId',
        render: (value) => value || '-',
      },
      {
        title: 'Order Lead',
        key: 'orderLeadName',
        width: 190,
        render: (value, record) =>
          record.orderLeadName || record.orderContactName || record.orderMobile ? (
            <div>
              <div>{record.orderLeadName || record.orderContactName || '-'}</div>
              <div style={{ color: '#888' }}>{record.orderMobile || ''}</div>
              {record.orderStatus ? <div style={{ color: '#888' }}>{record.orderStatus}</div> : null}
            </div>
          ) : (
            '-'
          ),
      },
      {
        title: 'Remarks',
        dataIndex: 'remarks',
        key: 'remarks',
        render: (value) =>
          value ? (
            <Tooltip title={value}>
              <span>{value.length > 45 ? `${value.slice(0, 45)}...` : value}</span>
            </Tooltip>
          ) : (
            '-'
          ),
      },
      {
        title: 'User',
        key: 'uploaderMobile',
        render: (value, record) => (
          <div>
            <div>{record.uploaderName || 'Unknown User'}</div>
            <div>{record.uploaderMobile || ''}</div>
          </div>
        ),
      },
      {
        title: 'Captured At',
        dataIndex: 'capturedAt',
        key: 'capturedAt',
        sorter: true,
        render: (value) => (
          <Tooltip title={formatIst(value)}>
            <span>{formatIst(value)}</span>
          </Tooltip>
        ),
      },
      {
        title: 'Uploaded At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (value) => formatIst(value),
      },
      {
        title: 'Action',
        dataIndex: 'imageUrl',
        key: 'action',
        width: 100,
        render: (url) => (
          <a href={url} target="_blank" rel="noopener noreferrer">
            <Button icon="export">Open</Button>
          </a>
        ),
      },
    ]

    return (
      <PageHeaderWrapper title={`All Photos & Videos: ${count}`}>
        <Card bordered={true}>
          <Select
            allowClear
            placeholder="Category"
            style={{ marginRight: 10, width: 190 }}
            onChange={(category) => this.reload({ category })}>
            <Option value="manufacturing_order">Production Order</Option>
            <Option value="inward">Inward</Option>
            <Option value="outward">Outward</Option>
          </Select>
          <Select
            allowClear
            placeholder="Type"
            style={{ marginRight: 10, width: 120 }}
            onChange={(mediaType) => this.reload({ mediaType })}>
            <Option value="photo">Photo</Option>
            <Option value="video">Video</Option>
          </Select>
          <Select
            allowClear
            placeholder="Subcategory"
            style={{ marginRight: 10, width: 170 }}
            onChange={(subcategory) => this.reload({ subcategory })}>
            <Option value="general">General</Option>
            <Option value="production_as_on">Production As On</Option>
            <Option value="completion">Completion</Option>
            <Option value="consumable">Consumable</Option>
            <Option value="manufacturing_order_outward">Manufacturing Order</Option>
            <Option value="dispatch_order">Dispatch Order</Option>
            <Option value="repair_order">Repair Order</Option>
            <Option value="outward_for_guard">Outward For Guard</Option>
            <Option value="box_picture">Box Picture</Option>
            <Option value="material">Material</Option>
            <Option value="counting_slip">Counting Slip</Option>
          </Select>
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            placeholder="User"
            style={{ marginRight: 10, width: 235 }}
            onChange={(uploaderMobile) => this.reload({ uploaderMobile })}>
            {users.map((user) => (
              <Option key={user.mobile} value={user.mobile}>
                {user.name} ({user.mobile})
              </Option>
            ))}
          </Select>
          <Search
            allowClear
            placeholder="Order ID"
            style={{ marginRight: 10, width: 180 }}
            onSearch={(orderId) => this.reload({ orderId })}
          />
          <RangePicker
            onChange={(capturedRange) => this.reload({ capturedRange })}
            style={{ marginBottom: 16 }}
          />
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            pagination={{
              defaultPageSize: 10,
              pageSizeOptions: ['10', '25', '50', '100'],
              showSizeChanger: true,
            }}
          />
        </Card>
        <Modal
          footer={null}
          title="Media Preview"
          visible={Boolean(previewUrl)}
          width={800}
          onCancel={() => this.setState({ previewUrl: undefined, previewMediaType: undefined })}>
          {previewUrl && previewMediaType === 'video' ? (
            <video controls src={previewUrl} style={{ width: '100%' }} />
          ) : previewUrl ? (
            <img alt="Full uploaded capture" src={previewUrl} style={{ width: '100%' }} />
          ) : null}
        </Modal>
      </PageHeaderWrapper>
    )
  }
}

export default Photos
